import * as localforage from "localforage";
import axios from "axios";

import { sortArrByName } from "../helpers/arrayHandlers";
import { setToken } from "./getToken";
import { setPermissions } from "./getPermisions";
import { setCurrentCompanyId } from "./getCurrentCompanyId";
import { setUserInfo } from "./getUserInfo";

export const authLogin = async ticket => {
  let response = await axios({
    url: `/api/v2/member/verify`,
    method: "POST",
    headers: {
      Accept: "application/json"
    },
    params: {
      ticket
    }
  });
  localStorage.setItem('lastLoginTime', Date.now())

  let loginData = response.data;

  if (loginData) {
    setToken(response.data.token);
    await localforage.setItem("user", response.data.user);
    await localforage.setItem("token", response.data.token);
    await localforage.setItem("expiredAt", response.data.expires_at);
    await localforage.setItem("companyId", response.data.user.company_id);
    await localforage.setItem("companyName", response.data.user.company.name);
    await localforage.setItem(
      "currentCompanyId",
      response.data.user.company_id
    );
    await localforage.setItem(
      "currentCompanyName",
      response.data.user.company.name
    );
    const companyArr = response.data.user.company.company_groups ?? [];
    const companyGroupsArr = companyArr.map(o => ({
      id: o.id,
      name: o.name
    }));
    const sortedCompanyGroupsArr = sortArrByName(companyGroupsArr);
    await localforage.setItem("companyGroups", sortedCompanyGroupsArr);
    //store user permissions name array
    const userPermissionsFromResponse =
      response.data.user.roles[0]?.permissions;
    if (userPermissionsFromResponse) {
      const userPermissionsNameArray = userPermissionsFromResponse.map(
        userPermissionFromResponse => {
          return userPermissionFromResponse.name;
        }
      );
      await localforage.setItem("userPermissions", userPermissionsNameArray);
      setUserInfo(response.data.user);
      setPermissions(userPermissionsNameArray);
      setCurrentCompanyId(response.data.user.company_id);
    }
    //window.location.replace('/');
    return true;
  } else {
    return false;
  }
};
